import axios from 'api/axios'
import { useEffect, useState } from 'react'

/**
 * @module FetchHooks
 */

/**
 * Fetch the calendar data for the user
 * @param {Object} props - The component props
 * @param {number} props.year - The year to see the calendar
 * @param {UserToHandle} [props.user] - The user to make the request
 * @param {string} props.requestCode - The code from the request
 * @param {string} props.requestOrigin - The origin from the request
 * @returns {UseFetchHookResponse<any>}
 */
const useFetchWidget = ({ year, user = null, requestCode = null, requestOrigin = null }) => {
  const [response, setResponse] = useState({})
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)
    setError(null)

    axios
      .get(
        `/calendariowidgets/?y=${year}&user=${user ?? ''}&s=${requestCode ?? ''}&o=${requestOrigin ?? ''}`,
      )
      .then((request_response) => {
        const data = request_response.data.computo_vacaciones
        const response = {
          autorizadas: data.autorizadas,
          pendientes: data.pendientes,
          disfrutados: data.disfrutados,
          pendientes_real: data.pendientes_real,
          tipo_dias: data.tipo_dias,
          permisos: data.permisos,
          solicitadas: data.solicitadas,
          solicitud_vacaciones_activa: data.solicitud_vacaciones_activa,
          disfruta_horas: data.disfruta_horas,
          horas_autorizadas: data.horas_autorizadas,
          horas_disfrutados: data.horas_disfrutados,
          horas_pendientes: data.horas_pendientes,
          horas_pendientes_real: data.horas_pendientes_real,
          horas_solicitadas: data.horas_solicitadas,
        }
        setResponse(response)
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchData()
  }, [year, user])

  return { response, error, loading }
}

export default useFetchWidget
